import { createAction, props } from '@ngrx/store';
import { NoteItem } from 'src/app/recruiting/candidates/live-nurses-new/components/notes/models/dto/note-item';
import { JobItem } from 'src/app/recruiting/candidates/live-nurses-new/components/jobs/models/dto/job-item';
import { PostedJobDto } from 'src/app/recruiting/candidates/live-nurses-new/components/job-profile/models/dto/posted-job';
import { SubmittalJobMatchCalculation } from '../../submittal/models/submittal-job-match-calculation.model';

export enum JobsActionEnum {
    LoadLiveNursesPostedJob = '[LIVE NURSES] Load Posted Job',
    LoadLiveNursesPostedJobSuccess = '[LIVE NURSES] Load Posted Job success',
    LoadLiveNursesPostedJobFail = '[LIVE NURSES] Load Posted Job fail',

    loadNotesForSubmittal = '[LIVE NURSES] Load Notes for Submittal',
    loadNotesForSubmittalSuccess = '[LIVE NURSES] Load Notes for Submittal success',
    loadNotesForSubmittalFail = '[LIVE NURSES] Load Notes for Submittal fail',

    addNote = '[LIVE NURSES] Add Note for Submittal',
    addNoteSuccess = '[LIVE NURSES] Add Note for Submittal success',
    addNoteFail = '[LIVE NURSES] Add Note for Submittal fail',

    loadJobOptions = '[LIVE NURSES] Load Job Options',
    loadJobOptionsSuccess = '[LIVE NURSES] Load Job Options success',
    loadJobOptionsFail = '[LIVE NURSES] Load Job Options fail',

    deleteJob = '[LIVE NURSES] Delete Job in submittal',
    deleteJobSuccess = '[LIVE NURSES] Delete Job in submittal success',
    deleteJobFail = '[LIVE NURSES] Delete Job in submittal fail',

    addJob = '[LIVE NURSES] Add Job for submittal',
    addJobSuccess = '[LIVE NURSES] Add Job for submittal Success',
    addJobFail = '[LIVE NURSES] Add Job for submittal Failed',
    resetLocalJobs = '[LIVE NURSES] ResetJobs locally',
    modifyingJobs = '[LIVE NURSES] Modifying Jobs',

    deleteSubmittal = '[LIVE NURSES] Delete Submittal in submittal',
    deleteSubmittalSuccess = '[LIVE NURSES] Delete Submittal success',
    deleteSubmittalFail = '[LIVE NURSES] Delete Submittal fail',

    loadJobPercentages = '[LIVE NURSES] Load Job Percentages',
    loadJobPercentagesSuccess = '[LIVE NURSES] Load Job Percentages Success',
    loadJobPercentagesFail = '[LIVE NURSES] Load Job Percentages fail',

    setSubmittalJobs = '[LIVE NURSES] Set Submittal Jobs',

    setSubmittalAsVerballyAccepted = '[RECRUITING ROW JOBS COMPONENT] Set Submittal as Verbally Accepted',
    setSubmittalAsVerballyAcceptedSuccess = '[SHARED OFFER SERVICE] Set Submittal as Verbally Accepted Success',
    setSubmittalAsVerballyAcceptedFailure = '[SHARED OFFER SERVICE] Set Submittal as Verbally Accepted Failure'
}

// Posted Job
export const loadLiveNursesPostedJob = createAction(JobsActionEnum.LoadLiveNursesPostedJob, props<{ jobId: number }>());
export const loadLiveNursesPostedJobSuccess = createAction(
    JobsActionEnum.LoadLiveNursesPostedJobSuccess,
    props<{ postedJob?: PostedJobDto }>()
);
export const loadLiveNursesPostedJobFail = createAction(
    JobsActionEnum.LoadLiveNursesPostedJobFail,
    props<{ error: any }>()
);

// Notes for submittal
export const loadNotesForSubmittal = createAction(
    JobsActionEnum.loadNotesForSubmittal,
    props<{ submittalId: number }>()
);
export const loadNotesForSubmittalSuccess = createAction(
    JobsActionEnum.loadNotesForSubmittalSuccess,
    props<{ notes: NoteItem[] }>()
);
export const loadNotesForSubmittalFail = createAction(
    JobsActionEnum.loadNotesForSubmittalFail,
    props<{ error: any }>()
);
export const addNote = createAction(JobsActionEnum.addNote, props<{ note: NoteItem }>());
export const addNoteSuccess = createAction(JobsActionEnum.addNoteSuccess, props<{ note: NoteItem }>());
export const addNoteFail = createAction(JobsActionEnum.addNoteFail, props<{ error: any }>());

// JobOptions
export const loadJobOptions = createAction(JobsActionEnum.loadJobOptions, props<{ submittalIds: number[] }>());
export const loadJobOptionsSuccess = createAction(
    JobsActionEnum.loadJobOptionsSuccess,
    props<{ submittalIds: number[]; jobOptions: JobItem[] }>()
);
export const loadJobOptionsFail = createAction(JobsActionEnum.loadJobOptionsFail, props<{ error: any }>());

// Submittal Jobs
export const deleteJob = createAction(
    JobsActionEnum.deleteJob,
    props<{
        jobId: number;
        submittalId: number;
        submittalStatusId?: number | null;
        submittalSubStatusId?: number | null;
    }>()
);
export const deleteJobSuccess = createAction(
    JobsActionEnum.deleteJobSuccess,
    props<{ jobId: number; submittalId: number }>()
);
export const deleteJobFail = createAction(JobsActionEnum.deleteJobFail, props<{ error: any }>());

export const addJob = createAction(JobsActionEnum.addJob, props<{ job: JobItem; submittalId: number }>());
export const addJobSuccess = createAction(
    JobsActionEnum.addJobSuccess,
    props<{ jobs: JobItem[]; submittalId: number }>()
);
export const addJobFail = createAction(JobsActionEnum.addJobFail, props<{ error: any }>());
export const resetStoreJobs = createAction(JobsActionEnum.resetLocalJobs);
export const modifyingJobs = createAction(JobsActionEnum.modifyingJobs, props<{ isBusy: boolean }>());

// Submittal
export const deleteSubmittal = createAction(
    JobsActionEnum.deleteSubmittal,
    props<{
        submittalId: number;
        reason: string;
        submittalStatusId?: number | null;
        submittalSubStatusId?: number | null;
    }>()
);
export const deleteSubmittalSuccess = createAction(
    JobsActionEnum.deleteSubmittalSuccess,
    props<{ submittalId: number }>()
);
export const deleteSubmittalFail = createAction(JobsActionEnum.deleteSubmittalFail, props<{ error: any }>());

// job percentages
export const loadJobPercentages = createAction(JobsActionEnum.loadJobPercentages, props<{ recruiterId: number }>());
export const loadJobPercentagesSuccess = createAction(
    JobsActionEnum.loadJobPercentagesSuccess,
    props<{ percentages: SubmittalJobMatchCalculation[] }>()
);
export const loadJobPercentagesFail = createAction(JobsActionEnum.loadJobPercentagesFail, props<{ error: any }>());

export const setSubmittalAsVerballyAccepted = createAction(
    JobsActionEnum.setSubmittalAsVerballyAccepted,
    props<{ offerId: number; isRecruiting: boolean }>()
);
export const setSubmittalAsVerballyAcceptedSuccess = createAction(
    JobsActionEnum.setSubmittalAsVerballyAcceptedSuccess,
    props<{ offerId: number }>()
);
export const setSubmittalAsVerballyAcceptedFailure = createAction(JobsActionEnum.setSubmittalAsVerballyAcceptedFailure);

export const setSubmittalJobs = createAction(JobsActionEnum.setSubmittalJobs, props<{ submittalJobs: JobItem[] }>());
